import { render } from "./AppCurrenciesSwitcher.vue?vue&type=template&id=4671e4b0&scoped=true"
import script from "./AppCurrenciesSwitcher.vue?vue&type=script&lang=js"
export * from "./AppCurrenciesSwitcher.vue?vue&type=script&lang=js"

import "./AppCurrenciesSwitcher.vue?vue&type=style&index=0&id=4671e4b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4671e4b0"]])

export default __exports__